import { getStore } from '../store/store';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * Indicates whether the user has ever selected calendars in Time Panel
 *
 * If not, we should fall back on using Calendar Module selected calendars config
 */
export function hasTimePanelSelectedCalendars(): boolean {
    if (!isFeatureEnabled('cal-time-panel-calendarPicker')) {
        return false;
    }

    // the store will not be marked as initialized until/unless:
    //   1. the user has Time Panel calendar config (loaded from scenario settings API)
    //   OR
    //   2. the user tries to toggle a calendar in the Time Panel calendar picker for the first time,
    //      at which point the Calendar module config will be cloned to initialize the Time Panel config
    return getStore().isInitialized;
}
